module.exports = __webpack_public_path__ + "img/HD_title_yyq_2_c9e480035.png";